import { Label } from "@/components/ui/label";

export function ChipGroup({ options, value, onChange, multi = true, testId }) {
  const selected = multi ? value || [] : [value];
  const toggle = (opt) => {
    if (!multi) return onChange(opt);
    onChange(selected.includes(opt) ? selected.filter((o) => o !== opt) : [...selected, opt]);
  };
  return (
    <div className="flex flex-wrap gap-2" data-testid={testId} role="group">
      {options.map((o) => {
        const val = typeof o === "string" ? o : o.value;
        const label = typeof o === "string" ? o : o.label;
        const on = selected.includes(val);
        return (
          <button
            type="button"
            key={val}
            onClick={() => toggle(val)}
            aria-pressed={on}
            className={`chip rounded-full border px-3.5 py-2 text-sm text-left ${on ? "bg-[#0B2A4A] text-[#F5ECD7] border-[#0B2A4A]" : "bg-white text-[#0B2A4A] border-[#0B2A4A]/20 hover:border-[#1A9AA8]"}`}
            data-testid={`${testId}-option-${val.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}

export function Field({ label, hint, children, htmlFor }) {
  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={htmlFor} className="text-sm font-semibold text-[#0B2A4A]">{label}</Label>
      {hint && <p className="text-xs text-slate-500 -mt-1">{hint}</p>}
      {children}
    </div>
  );
}

export function SectionLabel({ children }) {
  return <p className="font-mono-ui text-[11px] font-bold tracking-[0.25em] uppercase text-[#1A9AA8]">{children}</p>;
}

export function CheckRow({ checked, onChange, children, testId }) {
  return (
    <label className="flex items-start gap-3 text-sm text-slate-700 cursor-pointer">
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 h-4 w-4 accent-[#1A9AA8]" data-testid={testId} />
      <span>{children}</span>
    </label>
  );
}
